<template>
    <div class="row">
        <div class="col-12">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <!-- <li :class="fxsymbolprice == 0? 'active': ''" v-on:click.prevent="fxsymbolprice = 0"><a href="#">MAM/PAMM</a></li> -->
                <!-- <li :class="fxsymbolprice == 1? 'active': ''" v-on:click.prevent="fxsymbolprice = 1"><a href="#">{{$t('soclTrade_zullutrade')}}</a></li> -->
                <!-- <li :class="fxsymbolprice == 2? 'active': ''" v-on:click.prevent="fxsymbolprice = 2"><a href="#">Myfxbook AutoTrade</a></li> -->
                <li :class="fxsymbolprice == 3? 'active': ''" v-on:click.prevent="fxsymbolprice = 3"><a href="#">{{$t('soclTrade_mql')}}</a></li>
                <li :class="fxsymbolprice == 4? 'active': ''" v-on:click.prevent="fxsymbolprice = 4" v-if="get_user && get_user.is_ib_mamm && parseInt(get_user.is_ib_mamm) === 1"><a href="#">{{$t('mampamm_account_tab')}}</a></li>
            </ul>
        </div>
        <div class="col-12" v-if="fxsymbolprice == 0">
            <app-MamPamm></app-MamPamm>
        </div>
        <!-- <div class="col-12"  v-if="fxsymbolprice == 1">
           <app-ZuluTrade></app-ZuluTrade>
        </div> -->
        <!-- <div class="col-12" v-if="fxsymbolprice == 2">
            <app-MyFxbook></app-MyFxbook>
        </div> -->
        <div class="col-12" v-if="fxsymbolprice == 3">
            <app-Mql5></app-Mql5>
        </div>
        <div class="col-12" v-if="fxsymbolprice == 4">
            <mamPammAccounts />
        </div>
    </div>
</template>
<script>
    import MamPamm from './pages/mam_pamm'
    import ZuluTrade from './pages/zulu_trade'
    // import MyFxbook from './pages/myfxbook'
    import Mql5 from './pages/mql5'
    import MamPammAccounts from './pages/mam_pamm_accounts'
    export default {
        name: 'mam-pamm',
        data() {
            return {               
                fxsymbolprice : '3'
            }
        },
        components:{
            appMamPamm : MamPamm,
            appZuluTrade : ZuluTrade,
            // appMyFxbook : MyFxbook,
            appMql5 : Mql5,
            mamPammAccounts : MamPammAccounts
        },
        created() {
            if (this.$router.history && this.$router.history.current && this.$router.history.current.query && this.$router.history.current.query.tab && this.$router.history.current.query.tab === 'ib' && this.get_user && this.get_user.is_ib_mamm && parseInt(this.get_user.is_ib_mamm) === 1) {
                this.fxsymbolprice = '4';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/socialTrade/social_trade.vue